import { PeekStack } from "@piiqtechnologies/ui-components";
import React from "react";
const TablePanelContainer = ({ children, sx }) => {
    return (React.createElement(PeekStack, { pt: 1.5, sx: sx }, children));
};
export default TablePanelContainer;
